import { computed } from 'vue';
import type { IdSearch } from '@/components/ui/IdSearch';
import {
  AccountActions,
  CardActions,
  CardTokenActions,
} from '@/integrations/Immersve/auth/actions';
import { useAuthStore } from '@/stores/auth.store';

export const accountSearch: IdSearch = {
  name: 'account',
  title: 'Cards',
  subtitle: 'Cards issued to an account, newest first.',
  label: 'Account ID',
  read: (route) => route.query.account,
  to: (id) => ({ path: '/cards', query: { account: id } }),
  clearPath: '/cards',
};

export const cardSearch: IdSearch = {
  name: 'card',
  title: 'Card',
  subtitle: 'A card and its tokens.',
  label: 'Card ID',
  read: (route) => route.params.cardId,
  to: (id) => `/cards/${encodeURIComponent(id)}`,
  clearPath: '/cards',
};

// The searches the user may run, asked on any account as the pages do:
// amethyst lists an account's cards under account:read, and serves a card
// under card:read or card-token:read.
export function useCardSearches() {
  const authStore = useAuthStore();
  function holds(action: string): boolean {
    return authStore.user?.isAuthorised(action) ?? false;
  }
  return computed(() => [
    ...(holds(AccountActions.Read) ? [accountSearch] : []),
    ...([CardActions.Read, CardTokenActions.Read].some(holds) ? [cardSearch] : []),
  ]);
}
